import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.set";
import _toConsumableArray from "/home/opter/repo/code/cloudsee-web/node_modules/@babel/runtime-corejs2/helpers/esm/toConsumableArray.js";
import _regeneratorRuntime from "/home/opter/repo/code/cloudsee-web/node_modules/@babel/runtime-corejs2/helpers/esm/regeneratorRuntime.js";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/home/opter/repo/code/cloudsee-web/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import "core-js/modules/es6.number.constructor";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import * as constants from '@/constants';
export default {
  props: {
    title: {
      type: String,
      default: '关联项目'
    },
    areas: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    canSelect: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    selected: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    limit: {
      type: Number,
      default: -1
    }
  },
  data: function data() {
    return {
      constants: constants,
      tableHeight: 380,
      areaName: null,
      areaNameTemp: null,
      areaList: [],
      areaListTemp: [],
      areaListTemp2: [],
      currentPage: 1,
      pageSize: 100,
      total: 0,
      selectedRow: null,
      paginatedAreaList: []
    };
  },
  created: function created() {
    var _this = this;
    this.areaList = this.areas;
    this.areaListTemp = this.areas.filter(function (e) {
      return _this.selected.includes(e.areaId);
    });
    this.initData();
  },
  methods: {
    initData: function () {
      var _initData = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              this.total = this.areas.length;
              this.updatePaginatedAreaList();
            case 2:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function initData() {
        return _initData.apply(this, arguments);
      }
      return initData;
    }(),
    handleSizeChange: function handleSizeChange(size) {
      this.pageSize = size;
      this.updatePaginatedAreaList();
    },
    handleCurrentChange: function handleCurrentChange(page) {
      this.currentPage = page;
      this.updatePaginatedAreaList();
    },
    onSelectionChange: function onSelectionChange(selectedRow) {
      this.selectedRow = selectedRow;
    },
    /**
     * 关闭窗口清空数据
     */
    onBeforeClose: function onBeforeClose() {
      this.$emit("close");
    },
    /**
     * 添加
     * tips: 不可重复关联
     */
    onAddRows: function onAddRows() {
      var selectedRows = this.selectedRow || [];
      this.areaListTemp = _toConsumableArray(new Set([].concat(_toConsumableArray(this.areaListTemp), _toConsumableArray(selectedRows))));
      this.areaListTemp2 = _toConsumableArray(new Set([].concat(_toConsumableArray(this.areaListTemp), _toConsumableArray(selectedRows))));
    },
    /**
     * 删除项目
     */
    onDeleteArea: function onDeleteArea(index) {
      this.areaListTemp.splice(index, 1);
      this.areaListTemp2.splice(index, 1);
    },
    /**
     * 删除已选中项目
     */
    onDeleteSelectArea: function onDeleteSelectArea() {
      this.areaListTemp = [];
      this.areaListTemp2 = [];
    },
    /**
     * 搜索已选中项目
     */
    searchAreaTempList: function searchAreaTempList() {
      var _this2 = this;
      if (this.areaNameTemp) {
        this.areaListTemp = this.areaListTemp.filter(function (item) {
          return _this2.areaNameTemp ? item.areaName.indexOf((_this2.areaNameTemp || '').trim()) > -1 : true;
        });
      } else {
        this.areaListTemp = this.areaListTemp2;
      }
    },
    /**
     * 搜索项目列表
     */
    searchAreaList: function searchAreaList() {
      var _this3 = this;
      this.currentPage = 1; // 搜索后重置到第一页
      if (this.areaName && this.areaList.length > 0) {
        console.log("123123");
        this.areaList = this.areaList.filter(function (item) {
          return _this3.areaName ? item.areaName.indexOf((_this3.areaName || '').trim()) > -1 : true;
        });
      } else {
        this.areaList = this.areas;
        this.paginatedAreaList = this.areas;
      }
      this.updatePaginatedAreaList();
    },
    updatePaginatedAreaList: function updatePaginatedAreaList() {
      if (!this.areaList || this.areaList.length === 0) {
        return;
      }
      var start = (this.currentPage - 1) * this.pageSize;
      var end = start + this.pageSize;
      this.paginatedAreaList = this.areaList.slice(start, end);
      this.total = this.areaList.length; // 更新 total 的值
    },
    /**
     * 提交
     */
    onSubmit: function onSubmit() {
      var val = this.areaListTemp.map(function (item) {
        return item.areaId;
      });
      this.$emit("OnChange", val);
      this.onBeforeClose();
    }
  }
};